module.exports = __webpack_public_path__ + "img/success-check.ac4e5e63.svg";